export default "__VITE_ASSET__$QzP67ci__"